<template>
  <v-layout row wrap>
    <v-flex xs12>
      <ul class="stages_list">
        <li v-for="s in items" :class="{ 'active' : s.id == value, 'editable': editable }" @click="changeState(s)"><span>{{s.nazev}}</span></li>
      </ul>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  data: function () {
    return {
      items: [],
      item: null
    }
  },
  props: {
    value: Number,
    editable: Boolean
  },
  watch: {
    item (v) {
      this.$emit("changed", v);
      this.$emit("input", v.id);
    }
  },
  mounted: function() {
    this.load();
  },
  methods: {
    load: function(v) {
      window.api.get("ciselniky/stavy_objednavek").then(function(_body) {
        this.items = _body;
        if (this.value != null) {
          var $f = this.items.filter((x) => x.id == this.value);
          if ($f.length > 0)
            this.item = $f[0];
          else
            this.item = _body.length > 0 ? $r[0] : null;
        }
        else {
          this.item = _body.length > 0 ? $r[0] : null;
        }
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    changeState: function(v) {
      if (this.$props.editable)
        this.item = v;
    }
  },
  components: {

  }
}
</script>
<style scoped>
.v-select__selection-text {
  max-width: 100px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/StavObjednavky.vue